const SELECTOR = '[data-search-sort]';

class SearchSortTrigger {
  constructor() {

    $('body').on('change', SELECTOR, event => {
      $(event.target).closest('form').submit();
    });
  }
}

export default SearchSortTrigger;



// WEBPACK FOOTER //
// ./src/javascripts/SearchSortTrigger.js